// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2b17afd9","667":"617073fc","977":"2ca96652"}[chunkId] + ".chunk.js";
};